import React from "react";
import classNames from "classnames";
import { Link } from "react-router-dom";
import { connect } from "react-redux";

import ConfirmationDialog from "../../../../components/Modals/ConfirmationDialog";
import useModal from "../../../../hooks/useModal";
import {
  removeBundle,
  changeBundleStatus,
} from "../../../../store/dashboard/Bundles/actions";
import {
  COURSES_STATUSES,
} from "../../../../constants/courses";
import {
  getPublishModalDescription,
} from "../../../../constants/bundles";

import styles from "../../dashboard.module.scss";
import componentStyles from "./index.module.scss";
import Icon from "../../../../components/Common/Icon";
import ShowVideoInModal from '../../../../components/Modals/ShowVideoInModal';
import ShowVideoInfoInModal from '../../../../components/Modals/ShowVideoInfoInModal';

const DELETE_MODAL_TITLE = "Delete a bundle";
const DELETE_MODAL_DESCRIPTION =
  "Bundle info will be deleted. Are you sure you want to delete this bundle?";
const PUBLISH_MODAL_TITLE = "Publish bundle";

const VideoTableRow = ({ video, removeBundle, changeBundleStatus }) => {
  const [modalVisible, toggleModal] = useModal();
  const [videoWhereUsedModalVisible, toggleVideoWhereUsedModal] = useModal();
  const [publishModalVisible, togglePublishModal] = useModal();

  // const handleConfirmVideoPreview = () => {
  //   toggleModal();
  // };

  // const handleConfirmPublish = () => {
  //   togglePublishModal();
  //   changeBundleStatus(video.id);
  // };
  return (
    <>
      {/* <ConfirmationDialog
        isOpen={modalVisible}
        titleText={DELETE_MODAL_TITLE}
        contentText={DELETE_MODAL_DESCRIPTION}
        cancelButtonText="No"
        confirmButtonText="Yes"
        onCancel={() => toggleModal()}
        onConfirm={handleConfirmRemove}
        altBtnStyle
      />
      <ConfirmationDialog
        isOpen={publishModalVisible}
        titleText={PUBLISH_MODAL_TITLE}
        contentHtmlText={getPublishModalDescription(video.title)}
        cancelButtonText="No"
        confirmButtonText="Yes"
        onCancel={() => togglePublishModal()}
        onConfirm={handleConfirmPublish}
        altBtnStyle
      /> */}
      <ShowVideoInModal
        isOpen={modalVisible}
        onConfirm={() => toggleModal()}
        onCancel={() => toggleModal(false)}
        video={video}
      />
      <ShowVideoInfoInModal
        isOpen={videoWhereUsedModalVisible}
        onConfirm={() => toggleVideoWhereUsedModal()}
        onCancel={() => toggleVideoWhereUsedModal(false)}
        video={video}
      />
      <tr>
        <td className={classNames(styles.tableTitle, "align-middle")}>
          <p
            className={styles.tableTitle}
          >
            {video.id}
          </p>
        </td>
        <td className={classNames(styles.tableTitle, "align-middle")}>
          <p
            className={styles.tableTitle}
          >
            {video.title}
          </p>
        </td>
        <td className={classNames(styles.tableTitle, "align-middle")}>
          <p
            className={styles.tableTitle}
          >
            {video.translateVideoJobs.length > 0 ? video.translateVideoJobs[0].jobId : '-'}
          </p>
        </td>
        <td className={classNames(styles.tableTitle, "align-middle")}>
          <p
            className={classNames(styles.tableTitle, "d-flex flex-wrap")}
          >
            {video.fileTags.map(tag => {
              return (<span className={classNames(componentStyles.videoLibraryTags, 'mr-1')}>
              {tag.name}
            </span>)
            })}
          </p>
        </td>
        <td className="d-flex justify-content-end w-220px font-size-20 pr-5 ">
          <Link to="#" onClick={() => toggleModal()}>
            <i className="bx bx-play-circle text-grey mr-3" />
          </Link>
          <Link to="#" onClick={() => toggleVideoWhereUsedModal()}>
            <i className="bx bx-show text-grey mr-3" />
          </Link>
          <Link to={`/video-library/${video.id}`}>
            <i className="bx bx-edit text-grey mr-3" />
          </Link>
          {/* <Link to="#" onClick={() => toggleModal()}>
            <i className="bx bx-trash text-grey" />
          </Link> */}
        </td>
      </tr>
    </>
  );
};

export default connect(() => ({}), { removeBundle, changeBundleStatus })(
  VideoTableRow
);
